var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelegram = function SvgIconTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.5,
    fill: "#fff",
    fillOpacity: 0.12,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M17.5 3c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14m4.83 19.707c.257-.79 1.463-8.665 1.612-10.216.046-.47-.103-.782-.394-.922-.352-.169-.873-.084-1.477.133-.83.3-11.428 4.8-12.04 5.06-.581.247-1.13.516-1.13.905 0 .274.162.428.61.588.467.166 1.64.522 2.334.713.668.185 1.428.025 1.854-.24.452-.28 5.664-3.768 6.039-4.074.373-.306.672.086.366.392s-3.883 3.778-4.355 4.26c-.573.583-.166 1.188.218 1.43.439.276 3.595 2.394 4.07 2.733.475.34.957.494 1.399.494.441 0 .674-.581.893-1.257"
  })));
};
export default SvgIconTelegram;